var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "h5",
              { staticClass: "title-section" },
              [
                _vm._v("Data Strategy"),
                _c("br"),
                _c(
                  "b-button",
                  {
                    staticClass: "ml-1",
                    attrs: {
                      size: "sm",
                      variant: "outline-primary",
                      title: "Update Data",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onOpenEditor()
                      },
                    },
                  },
                  [
                    _c("b-icon", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.show_editor,
                          expression: "!show_editor",
                        },
                      ],
                      attrs: { icon: "pencil-fill" },
                    }),
                    _c("b-icon", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show_editor,
                          expression: "show_editor",
                        },
                      ],
                      attrs: { icon: "arrow-left" },
                    }),
                  ],
                  1
                ),
                _c("br"),
                !_vm.show_editor
                  ? _c("div", { staticClass: "vision" })
                  : _vm._e(),
                _vm.show_editor
                  ? _c(
                      "b-tabs",
                      { attrs: { "content-class": "mt-3" } },
                      [
                        _c(
                          "b-tab",
                          { attrs: { title: "Strategic Data Plan" } },
                          [_c("plan-data-list")],
                          1
                        ),
                        _c(
                          "b-tab",
                          { attrs: { title: "Strategic Plan" } },
                          [_c("plan-pilar-list")],
                          1
                        ),
                        _c(
                          "b-tab",
                          { attrs: { title: "Functional Divisions" } },
                          [_c("division-list")],
                          1
                        ),
                        _c(
                          "b-tab",
                          { attrs: { title: "Source Systems" } },
                          [_c("system-list")],
                          1
                        ),
                        _c(
                          "b-tab",
                          { attrs: { title: "Logical Entities" } },
                          [_c("entity-list")],
                          1
                        ),
                        _c(
                          "b-tab",
                          { attrs: { title: "Opportunities" } },
                          [_c("oportunity-list")],
                          1
                        ),
                        _c(
                          "b-tab",
                          { attrs: { title: "MVPs" } },
                          [_c("mvp-list")],
                          1
                        ),
                        _c(
                          "b-tab",
                          { attrs: { title: "Industry Values" } },
                          [_c("industry-list")],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "my-modal-meta",
          attrs: {
            id: "my-modal-meta",
            size: "xl",
            title: "Demo",
            "hide-footer": "",
            "no-close-on-backdrop": true,
            "no-close-on-esc": true,
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [_vm._v("Assign metadata in dev/test environment")]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("form-meta-report-datastudio", {
            attrs: {
              item: _vm.data_rp,
              report_id: _vm.data_rp.report_id,
              isChangeRequest: _vm.ACCESS_TYPE_FLOW.ASSIGN_DATA_OPERATOR,
              validateLink: _vm.isValidateLink,
            },
            on: { onCloseModal: _vm.onCloseModal, onSave: _vm.refreshItem },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }